import ActivateForm from './ActivateForm';

export default ActivateForm;
